import { css, jsx } from "@emotion/react";

export default {
  css,
  jsx,
};
